import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'i18n';
import b from 'i18n/richTextFormats/b';
import flexbox from 'styles/utils/flexbox';
import truncate from 'styles/utils/truncate';

function ContentCountry({ numberOfDestinations, numberOfHotels }) {
  return (
    <Container>
      <Numbers>
        <NumberOfDestinations>
          <FormattedMessage
            id='destinationCard.component.numberOfDestinations.label'
            description='<b>{number}</b> { number, plural, one {destination} other {destinations} }'
            defaultMessage='<b>{number}</b> { number, plural, one {destination} other {destinations} }'
            values={{ b, number: numberOfDestinations }}
            tagName={'span'}
          />
        </NumberOfDestinations>
        <NumberOfHotels>
          <FormattedMessage
            id='destinationCard.component.numberOfHotels.label'
            description='<b>{number}</b> { number, plural, one {hotel} other {hotels} }'
            defaultMessage='<b>{number}</b> { number, plural, one {hotel} other {hotels} }'
            values={{ b, number: numberOfHotels }}
            tagName={'span'}
          />
        </NumberOfHotels>
      </Numbers>
      <ExternalLink>
        <FontAwesomeIcon icon='external-link-alt' />
      </ExternalLink>
    </Container>
  );
}

export default ContentCountry;

const Container = styled.div`
  ${flexbox({})}
`;

const Numbers = styled.div`
  ${flexbox({
    flexDirection: 'column',
  })}

  width: 132px;
`;

const NumberedText = styled.div`
  ${truncate()}
  height: 42px;
  padding: 14px 6px;
  background-color: ${({ theme }) => theme.colors.primary.light};
  border: 1px solid;
  border-width: 0 0 0 1px;
  border-color: ${({ theme }) => theme.colors.primary.default};
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.3px;
  color: ${({ theme }) => theme.colors.text.templates.secondary};

  span {
    font-weight: 500;
  }
`;

const NumberOfDestinations = styled(NumberedText)`
  border-width: 0 0 1px 1px;
`;

const NumberOfHotels = styled(NumberedText)``;

const ExternalLink = styled.div`
  ${flexbox({
    justifyContent: 'center',
    alignItems: 'center',
  })}

  width: 38px;
  background-color: ${({ theme }) => theme.colors.primary.light};
  border: 1px solid;
  border-color: ${({ theme }) => theme.colors.primary.default};
  border-width: 0 0 0 1px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  font-size: 16px;
  text-align: center;
  cursor: pointer;

  svg {
    color: ${({ theme }) => theme.colors.text.templates.secondary};
  }
`;
